import styled from 'styled-components';

export const LoadingOverlayWrapper = styled.div`
	position: fixed;
  bottom: 40px;
  right: 40px;
  z-index: 100;
  color: #fff;
`
